import { createFileRoute } from "@tanstack/react-router";

import { OrganizationAthleteSubmissionPreviewPage } from "src/pages/OrganizationAthleteSubmissionPreviewPage";
export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/$questionnaireId/submissions/$submissionId/",
)({ component: OrganizationAthleteSubmissionPreviewPage });
